import { render, staticRenderFns } from "./BillingSettingsCard.vue?vue&type=template&id=070e2605"
import script from "./BillingSettingsCard.vue?vue&type=script&lang=js"
export * from "./BillingSettingsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports